import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/event/ueno/onlylive-logo.png'
import _imports_1 from '@/assets/img/event/ueno/ueno-top-img.png'
import _imports_2 from '@/assets/img/event/ueno/ueno-schedule.png'
import _imports_3 from '@/assets/img/event/ueno/ueno-main-top.png'
import _imports_4 from '@/assets/img/event/ueno/ueno-photograph.png'
import _imports_5 from '@/assets/img/event/ueno/ranking-benefits.png'
import _imports_6 from '@/assets/img/event/ueno/rank-top-img.png'
import _imports_7 from '@/assets/img/event/ueno/notes-img.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-bd62a096")

_pushScopeId("data-v-bd62a096")
const _hoisted_1 = { class: "ueno-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lp-header" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "onlylive-img",
    src: _imports_0
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ueno-top-img" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "ueno-image",
    src: _imports_1
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "event-period" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "period-img",
    src: _imports_2
  })
], -1)
const _hoisted_5 = { class: "ueno-main" }
const _hoisted_6 = { class: "ueno-main-top-container" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "ueno-main-top" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "ueno-main-content",
    src: _imports_3
  }),
  /*#__PURE__*/_createVNode("p", { class: "ueno-main-content-bottom" }, [
    /*#__PURE__*/_createTextVNode("配信時間・人数などに応じて決定されるランキングで1位〜3位の方は、"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("2022年2月にonlyliveの広告タレントとして「上野ビジョン広告」に掲載✨")
  ])
], -1)
const _hoisted_8 = { class: "left-bg-img" }
const _hoisted_9 = { class: "ueno-photograph" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "under-circle" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "photograph-circle-img",
    src: _imports_4
  })
], -1)
const _hoisted_11 = {
  class: "photograph-btn",
  href: "#benefits"
}
const _hoisted_12 = { class: "btn-content" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("特典をチェック")
const _hoisted_14 = /*#__PURE__*/_createVNode("div", {
  class: "benefits-bg",
  id: "benefits"
}, [
  /*#__PURE__*/_createVNode("div", { class: "benefits-section" }, [
    /*#__PURE__*/_createVNode("div", { class: "benefits-top" }, [
      /*#__PURE__*/_createVNode("div", { class: "benefits-top-img" }, [
        /*#__PURE__*/_createVNode("img", {
          class: "benefits-img",
          src: _imports_5
        })
      ]),
      /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_6 })
      ]),
      /*#__PURE__*/_createVNode("ul", { class: "benefits-content" }, [
        /*#__PURE__*/_createVNode("li", null, [
          /*#__PURE__*/_createTextVNode("onlyliveの広告タレントとして、"),
          /*#__PURE__*/_createVNode("br"),
          /*#__PURE__*/_createTextVNode("上野広小路・御徒町付近の"),
          /*#__PURE__*/_createVNode("br"),
          /*#__PURE__*/_createTextVNode("「上野ビジョン広告」に掲載！")
        ])
      ]),
      /*#__PURE__*/_createVNode("p", { class: "published-schedule" }, [
        /*#__PURE__*/_createTextVNode("（掲載・掲出期間 2022/2/1〜28"),
        /*#__PURE__*/_createVNode("br"),
        /*#__PURE__*/_createTextVNode("　72回/日 放映予定）")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "under-circle" }, [
      /*#__PURE__*/_createVNode("img", {
        class: "photograph-circle-img",
        src: _imports_4
      })
    ])
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "notes-section" }, [
  /*#__PURE__*/_createVNode("div", { class: "notes-section-container" }, [
    /*#__PURE__*/_createVNode("div", { class: "notes-top-title" }, [
      /*#__PURE__*/_createVNode("img", { src: _imports_7 })
    ]),
    /*#__PURE__*/_createVNode("ul", { class: "notes-contents" }, [
      /*#__PURE__*/_createVNode("li", null, "・2021年12月1日0時00分以降通話開始分から、2021年12月31日23時59分59秒通話開始分までがランキングに加算されます。"),
      /*#__PURE__*/_createVNode("li", null, "・2021年12月31日23時59分59秒に通話が開始された場合、終了するまでがランキングに加算されます。（延長分も加算されます）"),
      /*#__PURE__*/_createVNode("li", null, "・最終ランキングの発表は、2022年1月1日12:00を予定しております。")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ueno-footer" }, [
    /*#__PURE__*/_createVNode("p", null, "© 2021 ILEO,inc.")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("a", _hoisted_11, [
              _createVNode("p", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_font_awesome_icon, {
                  class: "chevron-icon",
                  icon: "chevron-down"
                })
              ])
            ])
          ])
        ])
      ]),
      _hoisted_14,
      _hoisted_15
    ])
  ]))
})